import { definePreset } from '../types/portal-settings';

// A parked portal. The only preset a deployment must name explicitly: it does
// not follow from productType + portalType, because any portal can be parked.
// Auth is skipped entirely and every route bounces to /coming-soon.
export default definePreset({
	homePage: 'comingSoon',
	pages: ['comingSoon'],
	features: {},
	comingSoon: {
		heading: 'Coming soon...',
		message: "We're putting the finishing touches on this portal.",
		contactEmail: 'support@linksoft.com.au',
		websiteUrl: 'https://www.linksoft.com.au',
	},
});
